import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';


export type JcTextInputType = "text" | "password" | "email" | "tel";
export type JcTextAutoComplete = "current-password" | "new-password" | "username" | "email" | "name" | "tel";

export interface JcTextInputProps extends JcCommonProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onEnter?: () => void;
  readonly onBlur?: () => void;
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly type?: JcTextInputType;
  readonly name?: string;
  readonly autoComplete?: JcTextAutoComplete;
}


export const JcTextInput = React.forwardRef<HTMLInputElement, JcTextInputProps>((props, ref) => {
  const isUsername = props.autoComplete === "username";
  const isName = props.autoComplete === "name";

  const id = useJcFieldId(props.id);
  const commonProps = JcUtils.commonProps({ ...props, id }, ["jc-input", "jc-text-input", isUsername && "jc-text-lowercase"]);

  return <input
    {...commonProps}
    ref={ref}
    type={props.type ?? "text"}
    name={props.name}
    autoComplete={props.autoComplete}
    value={props.value}
    placeholder={props.placeholder}
    disabled={props.disabled}
    onBlur={props.onBlur}
    autoCapitalize={isUsername ? "none" : isName ? "words" : undefined}
    autoCorrect={isUsername ? "off" : undefined}
    spellCheck={isUsername ? "false" : undefined}
    onKeyDown={(e) => {
      if (e.key === "Enter" && props.onEnter != null) {
        props.onEnter();
      }
    }}
    onChange={e => {
      let val = e.target.value;
      if (isUsername) {
        val = val.toLowerCase();
      }
      props.onChange(val);
    }} />;
});

JcTextInput.displayName = "JcTextInput";
